module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_133135787635503.86f7446d.jpg";